import { jsx as _jsx } from "react/jsx-runtime";
import { CheckCircleFilled, CloseCircleFilled, LoadingOutlined, ClockCircleOutlined, } from '@ant-design/icons';
import './style.less';
export const STATUS_VALUE = Object.freeze({
    RUNNING: Symbol('running'),
    DONE: Symbol('done'),
    WAITING: Symbol('waiting'),
    ERROR: Symbol('error'),
});
const TaskStatus = ({ status, size }) => {
    const className = `status-icon status-icon--${size}`;
    switch (status) {
        case STATUS_VALUE.RUNNING:
            return _jsx(LoadingOutlined, { className: className, spin: true });
        case STATUS_VALUE.DONE:
            return (_jsx(CheckCircleFilled, { className: className, style: { color: '#52c41a' } }));
        case STATUS_VALUE.WAITING:
            return _jsx(ClockCircleOutlined, { className: className });
        case STATUS_VALUE.ERROR:
            return (_jsx(CloseCircleFilled, { className: className, style: { color: 'red' } }));
        default:
            return null;
    }
};
export default TaskStatus;
